__turbopack_context__.v({
  "answer": "cmxq1q_answer",
  "answerArea": "cmxq1q_answerArea",
  "back": "cmxq1q_back",
  "bridge": "cmxq1q_bridge",
  "cell": "cmxq1q_cell",
  "composer": "cmxq1q_composer",
  "conversation": "cmxq1q_conversation",
  "dot": "cmxq1q_dot",
  "evidence": "cmxq1q_evidence",
  "evidenceTabs": "cmxq1q_evidenceTabs",
  "frame": "cmxq1q_frame",
  "grid": "cmxq1q_grid",
  "header": "cmxq1q_header",
  "nextStep": "cmxq1q_nextStep",
  "question": "cmxq1q_question",
  "receipt": "cmxq1q_receipt",
  "recordButton": "cmxq1q_recordButton",
  "resourcebar": "cmxq1q_resourcebar",
  "resourcefooter": "cmxq1q_resourcefooter",
  "resources": "cmxq1q_resources",
  "review": "cmxq1q_review",
  "workspace": "cmxq1q_workspace",
});
